import { useMutation, useQueryClient } from 'react-query'
import { removeForm } from 'api/services'

export const useRemoveForm = (options = {}) => {
  const queryClient = useQueryClient()
  const { onSuccess = () => {} } = options

  return useMutation(removeForm, {
    ...options,
    onSuccess: (data) => {
      queryClient.invalidateQueries('forms')
      onSuccess(data)
    },
  })
}
